import * as React from 'react'

export const MicrosoftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 2.204 6.557 1.3v6.336H0V2.204Zm0 11.592 6.557.904V8.443H0v5.353Zm7.279 1L16 16V8.443H7.279v6.353Zm0-13.592v6.432H16V0L7.279 1.204Z"
      fill="#282421"
    />
  </svg>
)
